module.exports = global["$"] = require("-!/var/www/html/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js
// module id = 30
// module chunks = 0